// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Form__Label = require("./Form__Label.bs.js");
var InputStyles = require("./InputStyles.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var ReactAriaComponents = require("react-aria-components");

var prependAppendBase = "shrink-0 flex justify-center items-center \n    border-solid border-zinc-300 border rounded-sm bg-zinc-100 \n    text-zinc-700 min-w-9 py-1.5 text-base";

var Styles = {
  prependAppendBase: prependAppendBase
};

function Form__Input(props) {
  var id = props.id;
  var append = props.append;
  var prepend = props.prepend;
  var status = props.status;
  var ___type = props.type;
  var labelText = props.labelText;
  var _type = ___type !== undefined ? ___type : "text";
  return JsxRuntime.jsxs(ReactAriaComponents.TextField, {
              children: [
                labelText !== undefined ? JsxRuntime.jsx(Form__Label.make, {
                        labelText: labelText,
                        optionalText: props.optionalText,
                        htmlFor: id
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        prepend !== undefined ? JsxRuntime.jsx("div", {
                                children: prepend,
                                className: TailwindMerge.twMerge([
                                      prependAppendBase,
                                      "border-r-0 rounded-r-none"
                                    ])
                              }) : null,
                        JsxRuntime.jsx(ReactAriaComponents.Input, {
                              className: (function (r) {
                                  return TailwindMerge.twMerge([
                                              InputStyles.baseInputStyles,
                                              InputStyles.inputStyles({
                                                    isFocused: r.isFocused,
                                                    isInvalid: r.isInvalid,
                                                    isDisabled: r.isDisabled,
                                                    status: status
                                                  }),
                                              "h-9",
                                              prepend !== undefined ? "rounded-l-none" : "",
                                              append !== undefined ? "rounded-r-none" : "",
                                              "[&::-webkit-search-decoration]:appearance-none \n            [&::-webkit-search-cancel-button]:appearance-none \n            [&::-webkit-search-results-button]:appearance-none \n            [&::-webkit-search-results-decoration]:appearance-none"
                                            ]);
                                }),
                              ref: props.inputRef,
                              onChange: props.onChange,
                              onKeyDown: props.onKeyDown,
                              onBlur: props.onBlur,
                              onFocus: props.onFocus,
                              autoFocus: props.autofocus,
                              disabled: props.disabled
                            }),
                        append !== undefined ? JsxRuntime.jsx("div", {
                                children: append,
                                className: TailwindMerge.twMerge([
                                      prependAppendBase,
                                      "border-l-0 rounded-l-none"
                                    ])
                              }) : null
                      ],
                      className: "flex flex-row"
                    })
              ],
              className: (function (_r) {
                  return "flex flex-col";
                }),
              id: id,
              value: props.value,
              defaultValue: props.defaultValue,
              autoComplete: props.autocomplete,
              placeholder: props.placeholderText,
              type: _type === "text" ? "text" : (
                  _type === "search" ? "search" : (
                      _type === "number" ? "number" : "password"
                    )
                ),
              inputMode: props.inputMode
            });
}

var make = Form__Input;

exports.Styles = Styles;
exports.make = make;
/* Form__Label Not a pure module */
